export const RESIGN_REASONS = {
  EXTERNAL_OFFER: 'External Offer',
  LOW_REMUNERATION: 'Low Remuneration',
  LOW_PERFORMANCE: 'Low Performance',
  FAILED_TRIAL_PERIOD: 'Failed Trial Period',
  PERSONAL_REASONS: 'Personal Reasons',
  OTHER: 'Other'
};

export const RESIGN_REASON_OPTIONS = [
  { value: RESIGN_REASONS.EXTERNAL_OFFER, label: RESIGN_REASONS.EXTERNAL_OFFER },
  { value: RESIGN_REASONS.LOW_REMUNERATION, label: RESIGN_REASONS.LOW_REMUNERATION },
  { value: RESIGN_REASONS.LOW_PERFORMANCE, label: RESIGN_REASONS.LOW_PERFORMANCE },
  { value: RESIGN_REASONS.FAILED_TRIAL_PERIOD, label: RESIGN_REASONS.FAILED_TRIAL_PERIOD },
  { value: RESIGN_REASONS.PERSONAL_REASONS, label: RESIGN_REASONS.PERSONAL_REASONS },
  { value: RESIGN_REASONS.OTHER, label: RESIGN_REASONS.OTHER }
];
